import { useState } from "react";

import { FormProvider } from "react-hook-form";

import { CREATE_STUDENT_PRACTITIONER_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";
import Stack from "@/tpo/Stack";

import ApplicationSubmitted from "../ApplicationSubmitted";
import Page from "./Page";
import ConfirmAndSubmit from "./sections/ConfirmAndSubmit";
import EducationalInstitution from "./sections/EducationalInstitution";
import YourDetails from "./sections/YourDetails";

export default function StudentApplicationLoggedOutForm() {
  const [submitted, setSubmitted] = useState(false);

  const api = useDjangoGraphqlForm({
    transformer: input => ({
      ...input,
      documents: JSON.stringify(
        input.documents.reduce((acc, doc) => {
          if (doc.type in acc) {
            return {
              ...acc,
              [doc.type]: [
                ...acc[doc.type],
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: ""
                }
              ]
            };
          } else {
            return {
              ...acc,
              [doc.type]: [
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: ""
                }
              ]
            };
          }
        }, {})
      )
    }),
    mutation: CREATE_STUDENT_PRACTITIONER_MUTATION,
    mutationName: "createStudentPractitionerMutation",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      businessLocationCity: "",
      businessCountry: "",
      password: "",
      confirmPassword: "",
      dateOfBirth: "",
      gender: "",
      institutionName: "",
      courseName: "",
      level: "",
      documents: [],
      acknowledgeSupport: false,
      acceptTerms: false
    },
    handleSuccess: () => {
      setSubmitted(true);
    }
  });

  if (submitted) {
    return <ApplicationSubmitted entity="Student Practitioner partner" />;
  }

  return (
    <Page>
      <FormProvider {...api.methods}>
        <Stack
          gap={[20, 20, 40]}
          as="form"
          onSubmit={e => {
            api.methods.clearErrors();
            api.methods.handleSubmit(api.onSubmit)(e);
          }}
        >
          <YourDetails readOnlyFields={[]} showLoginLink showPasswordFields showEmailHelpText />
          <EducationalInstitution />
          <ConfirmAndSubmit api={api} />
        </Stack>
      </FormProvider>
    </Page>
  );
}
